import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./OurProducts.css";

const OurProducts = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onHomeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutContainerClick = useCallback(() => {
    navigate("/aboutus");
  }, [navigate]);

  const onOurProductsTextClick = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopSecondaryClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  const onButtonDesktopPrimary1Click = useCallback(() => {
    navigate("/live-online-classes");
  }, [navigate]);

  return (
    <div className="our-products-div">
      <div className="nav-div2">
        <div className="logo1-div10" onClick={onLogo1ContainerClick}>
          <img className="vector-icon265" alt="" src="../vector.svg" />
          <img className="vector-icon266" alt="" src="../vector266.svg" />
          <img className="vector-icon267" alt="" src="../vector2.svg" />
          <img className="vector-icon268" alt="" src="../vector268.svg" />
          <img className="vector-icon269" alt="" src="../vector269.svg" />
          <img className="vector-icon270" alt="" src="../vector270.svg" />
          <img className="vector-icon271" alt="" src="../vector271.svg" />
          <img className="vector-icon272" alt="" src="../vector272.svg" />
          <img className="vector-icon273" alt="" src="../vector8.svg" />
          <img className="vector-icon274" alt="" src="../vector274.svg" />
          <img className="vector-icon275" alt="" src="../vector275.svg" />
          <img className="vector-icon276" alt="" src="../vector276.svg" />
          <img className="vector-icon277" alt="" src="../vector277.svg" />
          <img className="vector-icon278" alt="" src="../vector278.svg" />
          <img className="vector-icon279" alt="" src="../vector279.svg" />
          <img className="vector-icon280" alt="" src="../vector280.svg" />
          <img className="vector-icon281" alt="" src="../vector16.svg" />
          <img className="vector-icon282" alt="" src="../vector17.svg" />
          <img className="vector-icon283" alt="" src="../vector283.svg" />
          <img className="vector-icon284" alt="" src="../vector284.svg" />
          <img className="vector-icon285" alt="" src="../vector285.svg" />
          <img className="vector-icon286" alt="" src="../vector261.svg" />
          <img className="vector-icon287" alt="" src="../vector22.svg" />
          <img className="vector-icon288" alt="" src="../vector288.svg" />
          <img className="vector-icon289" alt="" src="../vector264.svg" />
          <b className="shuleeazy-b12">ShuleEazy</b>
        </div>
        <div className="frame-div109">
          <div className="frame-div110">
            <div className="home-div1" onClick={onHomeContainerClick}>
              <b className="home-b2">Home</b>
            </div>
            <div className="home-div1" onClick={onAboutContainerClick}>
              <b className="home-b2">About Us</b>
            </div>
            <div className="products-div2">
              <div className="frame-div111">
                <b className="our-products-b2" onClick={onOurProductsTextClick}>
                  Our Products
                </b>
                <img
                  className="outline-24px-chevron-down2"
                  alt=""
                  src="../outline-24px--chevrondown1.svg"
                />
              </div>
            </div>
            <div className="contact-div2">
              <b className="home-b2">Contact Us</b>
            </div>
          </div>
          <div className="frame-div112">
            <button
              className="buttondesktopsecondary4"
              onClick={onButtonDesktopSecondaryClick}
            >
              <b className="save-and-next23">log in</b>
            </button>
            <button
              className="buttondesktopprimary14"
              onClick={onButtonDesktopPrimaryClick}
            >
              <b className="save-and-next24">sign up</b>
            </button>
          </div>
        </div>
      </div>
      <div className="frame-div113">
        <div className="hero-div">
          <div className="hero-text-div">
            <b className="this-is-shuleeazy">This Is ShuleEazy</b>
            <div className="we-are-building-technology-for">
              <p className="we-are-building">{`We are building technology for students, teachers and parents, where they can be mentored by professionals in different fields. `}</p>
              <p className="we-are-building">
                We are also offering quality and affordable live online classes
                for students and an SMS Platform where they can learn for free.
              </p>
              <p className="explore-our-solution">
                Explore our solution for teachers, parents and students.
              </p>
            </div>
          </div>
          <img className="hero-image-icon" alt="" src="../hero-image.svg" />
        </div>
        <div className="products-div3">
          <div className="live-classes-div">
            <img
              className="live-classes-icon1"
              alt=""
              src="../live-classes1.svg"
            />
            <div className="frame-div114">
              <div className="frame-div115">
                <div className="frame-div116">
                  <b className="this-is-shuleeazy">Live Online Classes</b>
                  <b className="impactful-live-online-classes3">
                    <p className="we-are-building">{`Impactful live online classes `}</p>
                    <p className="explore-our-solution">
                      that focuses on your child’s growth
                    </p>
                  </b>
                </div>
                <div className="shuleeazy-provides-a-learning3">
                  <p className="we-are-building">{`ShuleEazy provides a learning environment that encourages students to take charge of their learning, engage with their classmates and teachers to solve issues, and think strategically. `}</p>
                  <p className="explore-our-solution">
                    Competency Based Curriculum (CBC) is used.
                  </p>
                </div>
              </div>
              <button
                className="buttondesktopprimary15"
                onClick={onButtonDesktopPrimary1Click}
              >
                <b className="save-and-next24">Learn more</b>
                <img
                  className="outline-24px-chevron-down2"
                  alt=""
                  src="../outline-24px--arrowright6.svg"
                />
              </button>
            </div>
          </div>
          <div className="sms-platform-div">
            <div className="frame-div114">
              <div className="frame-div115">
                <div className="frame-div116">
                  <b className="this-is-shuleeazy">SMS Platform</b>
                  <b className="impactful-live-online-classes3">
                    Build student knowledge through SMS
                  </b>
                </div>
                <div className="shuleeazy-provides-a-learning3">
                  <p className="we-are-building">{`We are aware that a huge population doesn’t have smartphones or the internet, that’s why as ShuleEazy we have also built an SMS Platform. `}</p>
                  <p className="explore-our-solution">
                    It is a skill-building platform possible with the simplest
                    feature phone.
                  </p>
                </div>
              </div>
              <button className="buttondesktopprimary15">
                <b className="save-and-next24">Learn more</b>
                <img
                  className="outline-24px-chevron-down2"
                  alt=""
                  src="../outline-24px--arrowright7.svg"
                />
              </button>
            </div>
            <img
              className="sms-platform-icon1"
              alt=""
              src="../sms-platform1.svg"
            />
          </div>
          <div className="mentorship-div">
            <img
              className="live-classes-icon1"
              alt=""
              src="../mentorship-sessions1.svg"
            />
            <div className="frame-div114">
              <div className="frame-div115">
                <div className="frame-div116">
                  <b className="this-is-shuleeazy">Mentorship Sessions</b>
                  <b className="impactful-live-online-classes3">
                    <p className="we-are-building">{`learn and grow with help from `}</p>
                    <p className="explore-our-solution">
                      world-class mentors for free
                    </p>
                  </b>
                </div>
                <div className="shuleeazy-provides-a-learning3">
                  <p className="we-are-building">
                    Once a member of ShuleEazy, you can book and meet mentors
                    for 1:1 mentorship.
                  </p>
                  <p className="we-are-building">{`Mentors are professionals who volunteer to turn their passions into conversations, friendships and networks. `}</p>
                  <p className="explore-our-solution">
                    Students, teachers and parents can book sessions with the
                    mentors
                  </p>
                </div>
              </div>
              <button className="buttondesktopprimary15">
                <b className="save-and-next24">Learn more</b>
                <img
                  className="outline-24px-chevron-down2"
                  alt=""
                  src="../outline-24px--arrowright6.svg"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-div2">
        <div className="frame-div123">
          <img
            className="outline-24px-chevron-down2"
            alt=""
            src="../antdesigncopyrightoutlined2.svg"
          />
          <b className="this-is-shuleeazy">
            2022 ShuleEazy, All Rights Reserved
          </b>
        </div>
      </div>
    </div>
  );
};

export default OurProducts;
